import { useState, useEffect } from "react";
import { LandingPage } from "./features/landing";
import { AppDiagnostics } from "./features/diagnostics";
import { SignInPage, SignUpPage, VerificationPage, DashboardPage } from "./features/identity";

export default function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };

    window.addEventListener("popstate", handleLocationChange);
    return () => {
      window.removeEventListener("popstate", handleLocationChange);
    };
  }, []);

  // Simple routing logic based on location pathname
  if (currentPath === "/status" || currentPath === "/diagnostics") {
    return <AppDiagnostics />;
  }

  if (currentPath === "/signin") {
    return <SignInPage />;
  }

  if (currentPath === "/signup") {
    return <SignUpPage />;
  }

  if (currentPath === "/verify") {
    return <VerificationPage />;
  }

  if (currentPath === "/coming-soon" || currentPath.startsWith("/w/")) {
    return <DashboardPage />;
  }

  return <LandingPage />;
}
